import idenityApi from '@/api/apiIdentity'


export default {

    // Process Api 

    changePwd(body) {
        // return Api.post(`/Identity/User/ActivateUser?email=${pwd}`) //?tenantID=' + id
        return idenityApi.put('/api/User/ChangeUserPassword', body)
    }
}